if (typeof authUser !== 'undefined' && authUser.rol_id == 3) {
    require('./buscador');
    require('./buscador-avanzado');
    require('./carrito');
    require('./pedidos');
    require('./favorito');
}

$(function () {
    window.header               = $('#header-middle, .header-bottom');
    window.stickyHeaderPosition = header.offset().top;
    window.onscroll             = function () {
        stickyHeader();
    };
});

function stickyHeader() {
    if (window.pageYOffset > stickyHeaderPosition) {
        header.addClass('sticky');
        $('#slideToBottom').addClass('sticky');
        $('body').addClass('is-sticky');
    } else {
        header.removeClass('sticky');
        $('#slideToBottom').removeClass('sticky');
        $('body').removeClass('is-sticky');
    }
}
